module.exports = __webpack_public_path__ + "img/logo_revisa.46dfec4f.png";